var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6572_132981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6604 8.68127C16.6604 8.114 16.6095 7.56855 16.5149 7.04492H8.98047V10.1394H13.2859C13.1004 11.1394 12.5368 11.9867 11.6895 12.5539V14.5612H14.275C15.7877 13.1685 16.6604 11.1176 16.6604 8.68127Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98104 16.4995C11.141 16.4995 12.9519 15.7831 14.2755 14.5613L11.6901 12.554C10.9737 13.034 10.0574 13.3177 8.98104 13.3177C6.89743 13.3177 5.13381 11.9104 4.50473 10.0195H1.83203V12.0922C3.14838 14.7067 5.8538 16.4995 8.98104 16.4995Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50406 10.0209C4.34407 9.54088 4.25316 9.02815 4.25316 8.50089C4.25316 7.97362 4.34407 7.4609 4.50406 6.98091V4.9082H1.83137C1.27137 6.023 0.979975 7.25335 0.980469 8.50089C0.980469 9.79178 1.28956 11.0136 1.83137 12.0936L4.50406 10.0209Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98104 3.68178C10.1556 3.68178 11.2101 4.08541 12.0392 4.87813L14.3337 2.58361C12.9483 1.29272 11.1374 0.5 8.98104 0.5C5.8538 0.5 3.14838 2.29271 1.83203 4.90722L4.50473 6.97992C5.13381 5.08904 6.89743 3.68178 8.98104 3.68178Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6572_132981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.980469 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.9c00f827f7bd0aa769b35a12755227a5.svg";
export { ForwardRef as ReactComponent };